import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import './NewTendersNotification.css';

class NewTendersNotification extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired
    };
    static defaultProps = {};
    state = {};

    constructor(props) {
        super(props);

        this.state.data = props.data;
    }

    render() {
        const {data, ...state} = this.state;
        return (
            <div className="widget-notifications-item">
                <div className="widget-notifications-title text-info">Новые тендеры</div>
                <div className="widget-notifications-description">
                    Появилось <a href="#"><strong>{data.tenderCount}</strong> новых тендеров</a>,
                    которые могут быть вам интересны
                </div>
                <div className="widget-notifications-date">
                    <Moment fromNow locale="ru">{data.timestamp}</Moment>
                </div>
                <div className="widget-notifications-icon fa fa-plus bg-info"/>
            </div>
        );
    }
}

export default NewTendersNotification;


// WEBPACK FOOTER //
// ./src/components/Notifications/NewTendersNotification.js